import React from 'react';

import { Text } from '@chakra-ui/react';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';

import api from 'api';
import { Button } from 'components';
import { TrainingStatus } from 'enums/status';

import TrainingItems from '../TrainingItems';

const actionText = {
  [TrainingStatus.Pending]: 'Iniciar Treinamento',
  [TrainingStatus.Ongoing]: 'Finalizar Treinamento',
  [TrainingStatus.InReview]: 'Treinamento Em Revisão',
  [TrainingStatus.Finished]: 'Treinamento Concluido',
};

export default function UserTraining({ refetch, data }) {
  const { content, id } = useParams<GeneralRoute>();
  const { mutate, isLoading } = useMutation((newData: any) => api().put(`/users/${content}/${id}`, newData), {
    onSuccess: () => refetch(),
  });

  const toggleStatus = () => {
    if (data.trainingStatus === TrainingStatus.Pending) {
      mutate({
        status: TrainingStatus.Ongoing,
      });
    }
    if (data.trainingStatus === TrainingStatus.Ongoing) {
      mutate({
        status: TrainingStatus.InReview,
      });
    }
  };

  return (
    <>
      <TrainingItems
        my={6}
        disabled={data.trainingStatus !== TrainingStatus.Ongoing}
        contents={data.contents}
      />
      <Button
        isLoading={isLoading}
        p={4}
        onClick={toggleStatus}
        disabled={[TrainingStatus.Finished, TrainingStatus.InReview].includes(data.trainingStatus)}
        alignSelf="flex-end"
        variant="primary.blue"
        width={300}>
        <Text variant="xLargeBold">{actionText[data.trainingStatus]}</Text>
      </Button>
    </>
  );
}
